import { Box, Typography } from "@mui/material";

interface ChooseFileProps {
  label?: string;
  fileName?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function ChooseFile(props: ChooseFileProps) {
  const {
    label = "Choose File",
    fileName = "No file chosen",
    onChange,
  } = props;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        textAlign: "center",
      }}
    >
      <label htmlFor="file-upload">
        <Box
          component="span"
          sx={{
            height: "40px",
            width: "135px",
            display: "inline-block",
            padding: "6px 16px",
            backgroundColor: "#D9D9D9",
            color: "#343133",
            borderRadius: "26px",
            border: "1px solid #000000",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "600",
          }}
        >
          {label}
        </Box>
      </label>
      <Typography variant="body1" color="#929191">
        {fileName}
      </Typography>
      <input
        id="file-upload"
        type="file"
        style={{ display: "none" }}
        onChange={onChange}
      />
    </Box>
  );
}
